import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../services/firebase";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {

    const [user, setUser] = useState(undefined);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, setUser);
        return () => unsubscribe();
    }, []);

    if (user === undefined) return <p>Loading...</p>;

    if (!user) return <Navigate to="/" replace />;
    
    return children;

}
